<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="10" sm="10" md="10" lg="8">
        <v-card class="elevation-12">
          <v-toolbar color="indigo" dark flat>
            <v-toolbar-title>Traceroute details:</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text>
            <v-form v-on:submit.prevent="startTrace">
              <v-select
                  v-model="selectedTraceFrom"
                  :items="traceFrom"
                  label="Start from"
                  item-text="label"
                  item-value="key"
                  v-if="traceFrom.length > 1"
              ></v-select>

              <v-text-field
                  label="IP Address or domain name"
                  v-model="endpoint"
                  prepend-icon="track_changes"
                  type="text"
              />
              <v-row>
                <v-col>
                  <v-switch
                      v-model="resolveHostnames"
                      class="ma-2"
                      label="Show hostnames/AS"
                  ></v-switch>
                </v-col>
                <v-col>
                  <v-switch
                      v-model="doNotAddToResultsBoard"
                      class="ma-2"
                      label="Do not show on results board"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-spacer/>

                <v-col>
                  <v-spacer/>

                  <v-btn block color="indigo" :loading="traceRunning" @click="startTrace"
                  >Start Trace
                  </v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <div id="adsgoeshere" v-html="adsenseContent"></div>

    <v-row align="center" justify="center">
      <v-col cols="10" sm="10" md="10" lg="8">
        <h2>Tracing route to {{ endpointLabel }}</h2>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="10" sm="10" md="10" lg="8">
        <GmapMap
            ref="traceMap"
            :center="center"
            :zoom="12"
            style="width: 100%; height: 400px"
        >
          <GmapMarker
              :key="address"
              v-for="(m, address) in markers"
              :position="m.position"
              :clickable="true"
              @click="markerClicked(m)"
          />
        </GmapMap>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="10" sm="10" md="10" lg="8">
        <template>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-left">Hop</th>
                <th class="text-left">IP</th>
                <th class="text-left" v-show="resolveHostnames">Host</th>
                <th class="text-left" v-show="resolveHostnames">AS</th>
                <th class="text-left">Min ms</th>
                <th class="text-left">Max ms</th>
                <th class="text-left">Average ms</th>
                <th class="text-left">Count</th>
              </tr>
              </thead>
              <tbody>
              <tr v-ripple v-for="item in traceLines" :key="item.hopId">
                <td>
                    <span v-show="item.selected"
                    ><v-icon>check_circle</v-icon></span
                    >
                </td>
                <td>{{ item.hopId }}</td>
                <td>{{ item.address }}</td>
                <td v-show="resolveHostnames">{{ item.hostname }}</td>
                <td v-show="resolveHostnames">{{ item.asDetail }}</td>
                <td>{{ item.minimumReplyTime }}</td>
                <td>{{ item.maximumReplyTime }}</td>
                <td>{{ item.average }}</td>
                <td>{{ item.count }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" vertical multi-line top>
      {{ feedbackText }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<style>
tr {
  position: relative;
  transform: scale(1);
}
</style>
<script>
import {HubConnectionBuilder, LogLevel} from "@aspnet/signalr";
import {gmapApi} from "vue2-google-maps";

export default {
  name: "InputForm",
  components: {},
  data: () => ({
    center: {lat: 52.8218, lng: -1.4252},
    adsenseContent: "",
    feedbackText: "",
    snackbar: false,
    endpoint: "",
    connection: "",
    traceLines: [],
    messages: [],
    rawResult: "",
    traceRunning: false,
    resolveHostnames: true,
    doNotAddToResultsBoard: false,
    isIp: false,
    allIps: [],
    endpointLabel: "",
    traceFrom: [
      {
        key: "uk-man",
        label: "UK, Manchester (more coming soon)",
      },
    ],
    selectedTraceFrom: "uk-man",
    coords: [],
    bound: null,
    polyline: null,
  }),

  created() {
    this.$vuetify.theme.dark = true;
    this.connection = new HubConnectionBuilder()
        .withUrl("/traceroute-hub")
        //.configureLogging(LogLevel.Information)
        .build();
    this.connection.start().catch(function (err) {
      return console.error(err);
    });
    var thisVue = this;
    var adsgoeshere = document.getElementById("adsgoeshere");
    if(adsgoeshere) thisVue.adsenseContent = adsgoeshere.innerHTML;

    //thisVue.connection.start();
    thisVue.connection.on("ReceiveMessage", function (message) {
      thisVue.messages.push({message});
    });
    thisVue.connection.on("StartingWith", function (message) {
      thisVue.endpointLabel = message.label;
      //thisVue.input = message.input;
      if (thisVue.$route.path.substring(1) !== message.input) thisVue.$router.push(message.input);
      thisVue.isIp = message.isIp;
      thisVue.allIps = message.allIps;
    });
    thisVue.connection.on("FeedbackError", function (message) {
      thisVue.feedbackText = message;
      thisVue.snackbar = true;
    });
    thisVue.connection.on("TraceRunning", function (message) {
      thisVue.traceRunning = message;
    });
    thisVue.connection.on("ReceiveRaw", function (message) {
      thisVue.rawResult += message;
    });
    thisVue.connection.on("TraceResponse", function (message) {
      //thisVue.connection.invoke("GetIpDetail", message.address);
      thisVue.traceLines.push(message);
    });
    thisVue.connection.on("IpDetailResponse", (message) => {
      var line = thisVue.traceLines.find((t) => t.address === message.address);
      if (line) {
        line.longitude = message.longitude;
        line.latitude = message.latitude;
        if (line.longitude !== 0 && line.latitude !== 0) {
          var location = {
            lat: +line.latitude,
            lng: +line.longitude,
          };
          line.position = location;

          this.bounds.extend(location);
          this.coords.push(location);
          this.$refs.traceMap.fitBounds(this.bounds);
          const lineSymbol = {
            path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          };
          this.polyline = new this.google.maps.Polyline({
            path: this.coords,
            geodesic: true,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [
              {
                icon: lineSymbol,
                offset: "60%",
              },
            ],
          });

          this.$refs.traceMap.$mapPromise.then((map) => {
            this.polyline.setMap(map);
          });
        }
        if (+message.asNumber === 0) return;
        line.asName = message.asName;
        line.asNumber = message.asNumber;
        line.asDetail = message.asNumber + " - " + message.asName;
      }
    });

    thisVue.connection.on("IpHostNameResponse", (message) => {
      var line = thisVue.traceLines.find((t) => t.address === message.address);
      if (line) {
        line.hostname = message.hostname;
      }
    });
    thisVue.connection.on("TraceTime", function (message) {
      const index = thisVue.traceLines.findIndex(
          (e) => e.hopId === message.hopId
      );

      if (index > -1) {
        var line = thisVue.traceLines[index];
        //thisVue.traceLines[index] = message
        line.minimumReplyTime = message.minimumReplyTime;
        line.maximumReplyTime = message.maximumReplyTime;
        line.sumOfReplyTime = message.sumOfReplyTime;
        line.count = message.count;
        line.average = (message.sumOfReplyTime / message.count).toFixed(2);
      }
    });

    if (thisVue.$route.name === "routename") {
      var endpoint = thisVue.$route.path.substring(1);
      thisVue.endpoint = endpoint;
      //thisVue.startTrace();
    }
  },
  methods: {
    startTrace: function () {
      var thisVue = this;
      thisVue.traceLines = [];
      this.bounds = new this.google.maps.LatLngBounds();
      if (this.polyline) this.polyline.setMap(null);

      this.coords = [];
      if (this.connection.state === 0) {
        this.connection.start();
      }
      thisVue.connection
          .invoke("StartTrace", this.endpoint, this.doNotAddToResultsBoard)
          .catch(function (err) {
            return console.error(err);
          });
    },
    markerClicked: function (data) {
      this.traceLines.forEach((line) => {
        //line.selected = line.longitue === data.longitue && line.latitude === data.latitude;
        this.$set(line, 'selected', line.longitue === data.longitue && line.latitude === data.latitude);
        // this.$nextTick(() => {
        // });
      });
    },
  },
  computed: {
    // a computed getter
    google: gmapApi,
    markers: function () {
      return this.traceLines.filter(
          (line) => line.latitude !== 0 && line.longitude !== 0
      );
    },
  },

  mounted: function () {
    // ---------
    // Call client methods from hub
    // ---------
  },
};
</script>
